import { useIntl } from "@leagueplatform/locales";
import GOOGLE_BADGE from "assets/google-play-badge.svg";
import { EXTERNAL_URLS } from "common/urls";
import { StoreLink } from "./store-link.component";

// English-only by design — same trade-off as the Apple badge. Localized
// PNGs in assets/google-store/ kept for safety; delete that directory if/
// when product confirms English-only is acceptable.
export const GoogleStoreLink = () => {
  const { formatMessage } = useIntl();

  return (
    <StoreLink
      href={EXTERNAL_URLS.GOOGLE_PLAY_STORE_APP}
      src={GOOGLE_BADGE}
      alt={formatMessage({ id: "STR_GET_GOOGLE_PLAY" })}
      css={{ width: "158px", height: "52px" }}
    />
  );
};
